module.exports = __webpack_public_path__ + "static/media/Nidorina_gaussian2.e6d58b30.png";